import { useQuery } from "@tanstack/react-query";

interface ShelterLocation {
  id: string;
  code: string;
  label: string;
  isActive: boolean;
  zoneCount: number;
  createdAt: string;
  updatedAt: string;
}

interface UseActiveLocationsResult {
  locations: ShelterLocation[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useActiveLocations(): UseActiveLocationsResult {
  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery<ShelterLocation[]>({
    queryKey: ["/api/locations"],
    staleTime: 5 * 60 * 1000,
    select: (locations) => locations.filter((loc) => loc.isActive),
  });

  return {
    locations: data || [],
    isLoading,
    error: error as Error | null,
    refetch,
  };
}
